export const formatShortCurrency = (value: number) => {
    if (value >= 1000000) {
        return `${(value / 1000000).toFixed(1)} mln`;
    }

    if (value >= 1000) {
        return `${(value / 1000).toFixed(0)} tys.`;
    }

    return value.toString();
};
